import { TMaterialsFormData } from 'src/@types';
import { IMaterialsSFilter } from 'src/@types/SearchFilterTypes';
import { IMaterials } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/material';

const convertDataInfoToFormData = (data: TMaterialsFormData) => {
  const formData = new FormData();
  formData.append('langCd', data.langCd);
  formData.append('title', data.title);
  formData.append('useYn', data.useYn?.toString());
  // 삭제할 파일
  if (data.deleteFilesPath && data.deleteFilesPath.length > 0) {
    data.deleteFilesPath.forEach((file) => {
      formData.append(`deleteFiles`, file);
    });
  }
  // 이미 등록되어있는 이미지
  if (data.filePath && data.filePath.length > 0) {
    data.filePath.forEach((file) => {
      formData.append(`filePath`, file);
    });
  }
  // 새로 업로드된 파일 추가
  if (data.files && data.files.length > 0) {
    data.files.forEach((file) => {
      formData.append(`files`, file);
    });
  }
  return formData;
};

/**
 * 목록 조회
 */
export const getMaterials = async (formData: IMaterialsSFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(formData);
    const response = await instance.get<TApiResponseData<IMaterials[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (materialSid: number) => {
  try {
    const url = `${SUB_URL}/${materialSid}`;
    const response = await instance.get<TApiResponseData<IMaterials>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: TMaterialsFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IMaterials>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정
 */
export const put = async (materialSid: number, data: TMaterialsFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}/${materialSid}`;

    const response = await instance.put<TApiResponseData<IMaterials>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 삭제
 */
export const remove = async (materialSid: number) => {
  try {
    const url = `${SUB_URL}/${materialSid}`;
    const response = await instance.delete<TApiResponseData<IMaterials>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
